export default __webpack_public_path__ + "static/media/24.ae8730fc.jpg";